var exports = {
  "Q": "xa15a2ab7--0df9a6--content",
};

module.exports = exports;
